import { HTMLAttributeAnchorTarget } from 'react';
import { IconName } from '@dapp/multi-lib/sdaoui/Icon';

export interface LinkProps {
  label: string;
  href?: string;
  target?: HTMLAttributeAnchorTarget | undefined;
}

export interface BaseMenuItem {
  hidden?: boolean;
  items?: BaseMenuItem[];
}

export interface MenuItem extends LinkProps, BaseMenuItem {
  icon?: IconName;
  items?: MenuItem[];
  isActive?: (item: MenuItem, path: string) => boolean;
}

export interface MenuItemMobile extends MenuItem {
  endIcon?: IconName;
}

export interface MenuGroup extends BaseMenuItem {
  label?: string;
  items: MenuItem[];
}

export type MenuGroupMobile = {
  label?: string;
  items: MenuItemMobile[];
};

export const isActive = (item: MenuItem, pathname: string) => {
  if (item.isActive) {
    return item.isActive(item, pathname);
  }

  return pathname.startsWith(item.href ?? '');
};

export const isActiveExact = (item: MenuItem, pathname: string) => {
  return item.href === pathname;
};

export const hasActive = (items: MenuItem[], pathname: string) => {
  return items.some((item) => item.href && pathname.startsWith(item.href));
};

export const removeHiddenItems = (
  acc: BaseMenuItem[],
  item: BaseMenuItem
): BaseMenuItem[] => {
  if (item.hidden === true) {
    return acc;
  }

  if (!item.items || item.items.length === 0) {
    return [...acc, item];
  }

  return [
    ...acc,
    {
      ...item,
      items: item.items.reduce(removeHiddenItems, []),
    },
  ];
};
